<template>
    <div
            v-if="isMobile || isTablet"
            class="landing-page-pro tw-h-auto tw-py-10 md:tw-px-10 tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center"
            :class="`${backgroundColor}`"
    >
        <div class="pro-user-wrapper tw-flex tw-flex-col tw-items-center tw-w-full">
            <div class="pro-user tw-flex tw-flex-col tw-items-center tw-w-full tw-justify-center">
                <storage-avatar
                        :user="user"
                        :size="8"
                />
                <user-details
                        :display-name="displayName"
                        :agent-occupation="occupation"
                        :phones="phones"
                        :email="email"
                        :website="website"
                        :active-listings="activeListings"
                        :license="loanOfficerLicense"
                        :company-name="companyName"
                        :primary-color="primaryColor"
                />
            </div>

            <div
                    v-if="hasExtras"
                    class="pro-socials-wrapper tw-flex tw-gap-4 tw-max-w-[28rem] tw-w-full tw-justify-end tw-px-[6rem] md:tw-justify-center tw-justify-center tw-mt-7"
            >
                <b-link
                        v-if="youtube"
                        :href="youtube.url"
                        target="_blank"
                >
                    <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                                d="M12.3516 12.1338L18.7266 15.7197L12.3516 19.3057V12.1338ZM29.75 3.96582V27.3408C29.75 29.1338 28.2891 30.5283 26.5625 30.5283H3.1875C1.39453 30.5283 0 29.1338 0 27.3408V3.96582C0 2.23926 1.39453 0.77832 3.1875 0.77832H26.5625C28.2891 0.77832 29.75 2.23926 29.75 3.96582ZM26.9609 15.7197C26.9609 15.7197 26.9609 11.7354 26.4297 9.87598C26.1641 8.81348 25.3008 7.9502 24.3047 7.68457C22.3789 7.15332 14.875 7.15332 14.875 7.15332C14.875 7.15332 7.30469 7.15332 5.37891 7.68457C4.38281 7.9502 3.51953 8.81348 3.25391 9.87598C2.78906 11.7354 2.78906 15.7197 2.78906 15.7197C2.78906 15.7197 2.78906 19.6377 3.25391 21.5635C3.51953 22.626 4.38281 23.4229 5.37891 23.6885C7.30469 24.1533 14.875 24.1533 14.875 24.1533C14.875 24.1533 22.3789 24.1533 24.3047 23.6885C25.3008 23.4229 26.1641 22.626 26.4297 21.5635C26.9609 19.6377 26.9609 15.7197 26.9609 15.7197Z"
                                :fill="primaryColor || '#064789'"
                        />
                    </svg>
                </b-link>
                <b-link
                        v-if="facebook"
                        :href="facebook.url"
                        target="_blank"
                >
                    <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                                d="M26.5625 0.77832C27.3594 0.77832 28.1562 1.17676 28.7539 1.77441C29.3516 2.37207 29.75 3.16895 29.75 3.96582V27.3408C29.75 28.2041 29.3516 29.001 28.7539 29.5986C28.1562 30.1963 27.3594 30.5283 26.5625 30.5283H17.3984V20.4346H21.25L21.9805 15.6533H17.3984V12.5986C17.3984 11.2705 18.0625 10.0088 20.1211 10.0088H22.1797V5.95801C22.1797 5.95801 20.3203 5.62598 18.4609 5.62598C14.7422 5.62598 12.2852 7.9502 12.2852 12.0674V15.6533H8.10156V20.4346H12.2852V30.5283H3.1875C2.32422 30.5283 1.52734 30.1963 0.929688 29.5986C0.332031 29.001 0 28.2041 0 27.3408V3.96582C0 3.16895 0.332031 2.37207 0.929688 1.77441C1.52734 1.17676 2.32422 0.77832 3.1875 0.77832H26.5625Z"
                                :fill="primaryColor || '#064789'"
                        />
                    </svg>
                </b-link>
                <b-link
                        v-if="instagram"
                        :href="instagram.url"
                        target="_blank"
                >
                    <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                                d="M14.875 12.1338C15.8047 12.1338 16.668 12.5322 17.332 13.1963C17.9961 13.8604 18.3945 14.7236 18.3945 15.6533C18.3945 17.1143 17.5312 18.4424 16.2031 18.9736C14.875 19.5049 13.3477 19.1729 12.3516 18.1768C11.3555 17.1807 11.0234 15.6533 11.5547 14.3252C12.0859 12.9971 13.4141 12.1338 14.875 12.1338ZM23.1094 9.41113C23.707 10.8057 23.5742 14.126 23.5742 15.6533C23.5742 17.2471 23.707 20.5674 23.1094 21.9619C22.7773 22.8916 22.0469 23.6221 21.1172 23.9541C19.7227 24.5518 16.4023 24.4189 14.875 24.4189C13.2812 24.4189 9.96094 24.5518 8.56641 23.9541C7.63672 23.6221 6.90625 22.8916 6.57422 21.9619C6.04297 20.5674 6.10938 17.2471 6.10938 15.6533C6.10938 14.126 6.04297 10.8057 6.57422 9.41113C6.90625 8.48145 7.63672 7.75098 8.56641 7.41895C9.96094 6.82129 13.2812 6.9541 14.875 6.9541C16.4023 6.9541 19.7227 6.82129 21.1172 7.41895C22.0469 7.75098 22.7773 8.48145 23.1094 9.41113ZM14.875 21.0986C16.2695 21.165 17.6641 20.5674 18.7266 19.5713C19.7227 18.5088 20.3203 17.1143 20.3203 15.6533C20.3203 13.4619 18.9922 11.4697 16.9336 10.6729C14.875 9.80957 12.5508 10.2744 11.0234 11.8682C9.42969 13.3955 8.96484 15.7197 9.82812 17.7783C10.625 19.8369 12.6172 21.0986 14.875 21.0986ZM20.5195 11.2705C20.8516 11.2705 21.1836 11.1377 21.3828 10.9385C21.6484 10.6729 21.7812 10.3408 21.7812 10.0088C21.7812 9.47754 21.4492 9.0127 20.9844 8.81348C20.5195 8.61426 19.9883 8.74707 19.5898 9.14551C19.2578 9.47754 19.125 10.0088 19.3242 10.4736C19.5234 11.0049 19.9883 11.2705 20.5195 11.2705ZM26.5625 0.77832C27.3594 0.77832 28.1562 1.17676 28.7539 1.77441C29.3516 2.37207 29.75 3.16895 29.75 3.96582V27.3408C29.75 28.2041 29.3516 29.001 28.7539 29.5986C28.1562 30.1963 27.3594 30.5283 26.5625 30.5283H3.1875C2.32422 30.5283 1.52734 30.1963 0.929688 29.5986C0.332031 29.001 0 28.2041 0 27.3408V3.96582C0 3.16895 0.332031 2.37207 0.929688 1.77441C1.52734 1.17676 2.32422 0.77832 3.1875 0.77832H26.5625ZM25.3672 20.0361C25.5 18.3096 25.5 13.0635 25.3672 11.3369C25.3008 9.61035 24.9023 8.08301 23.707 6.8877C22.4453 5.62598 20.918 5.22754 19.2578 5.16113C17.4648 5.02832 12.2188 5.02832 10.4922 5.16113C8.76562 5.22754 7.23828 5.62598 6.04297 6.82129C4.78125 8.08301 4.38281 9.61035 4.31641 11.2705C4.18359 13.0635 4.18359 18.3096 4.31641 20.0361C4.38281 21.7627 4.78125 23.29 6.04297 24.4854C7.23828 25.7471 8.76562 26.1455 10.4922 26.2119C12.2188 26.3447 17.4648 26.3447 19.2578 26.2119C20.918 26.1455 22.4453 25.7471 23.707 24.4854C24.9023 23.29 25.3008 21.7627 25.3672 20.0361Z"
                                :fill="primaryColor || '#064789'"
                        />
                    </svg>
                </b-link>
                <b-link
                        v-if="linkedin"
                        :href="linkedin.url"
                        target="_blank"
                >
                    <svg
                            width="30"
                            height="31"
                            viewBox="0 0 30 31"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                                d="M27.625 0.77832C28.7539 0.77832 29.75 1.77441 29.75 2.96973V28.4033C29.75 29.5986 28.7539 30.5283 27.625 30.5283H2.05859C0.929688 30.5283 0 29.5986 0 28.4033V2.96973C0 1.77441 0.929688 0.77832 2.05859 0.77832H27.625ZM8.96484 26.2783V12.1338H4.58203V26.2783H8.96484ZM6.77344 10.1416C8.16797 10.1416 9.29688 9.0127 9.29688 7.61816C9.29688 6.22363 8.16797 5.02832 6.77344 5.02832C5.3125 5.02832 4.18359 6.22363 4.18359 7.61816C4.18359 9.0127 5.3125 10.1416 6.77344 10.1416ZM25.5 26.2783V18.5088C25.5 14.7236 24.6367 11.7354 20.1875 11.7354C18.0625 11.7354 16.6016 12.9307 16.0039 14.0596H15.9375V12.1338H11.7539V26.2783H16.1367V19.3057C16.1367 17.4463 16.4688 15.6533 18.793 15.6533C21.0508 15.6533 21.0508 17.7783 21.0508 19.3721V26.2783H25.5Z"
                                :fill="primaryColor || '#064789'"
                        />
                    </svg>
                </b-link>
            </div>
            <div
                    v-if="!isEmpty(companyLogo)"
                    class="pro-company-logo 3xl:tw-h-[7.5rem] 3xl:tw-w-[7.5rem] xl:tw-w-[6.75rem] xl:tw-h-[6.75rem] tw-w-44 tw-h-[7.5rem] tw-mt-16"
            >
                <img
                        class="tw-w-full tw-h-full tw-object-contain"
                        :src="companyLogo"
                        alt="Company logo"
                />
            </div>
            <div
                    v-if="hasExtras"
                    class="tw-mb-8 md:tw-justify-center md:tw-gap-4 tw-max-h-[4.5rem] tw-max-w-[28rem] tw-h-full tw-w-full tw-px-[6rem] tw-flex tw-justify-center tw-items-center tw-mt-16"
            >
                <div class="tw-max-h-[4.5rem] tw-max-w-[4.5rem] tw-h-full tw-w-full">
                    <img
                            class="tw-max-h-[4.5rem] tw-max-w-[4.5rem]"
                            :src="require('@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/equal-housing-opportunity.png')"
                            alt="image desc"
                    >
                </div>
                <div class="tw-max-h-[4.5rem] tw-max-w-[4.5rem] tw-h-full tw-w-full">
                    <img
                            class="tw-max-h-[4.5rem] tw-max-w-[4.5rem]"
                            :src="require('@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/equal-housing-lender.png')"
                            alt="image desc"
                    >
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-px-10 tw-pb-5">
                <div class="tw-pb-1">
                    <p class="tw-inline tw-font-sans">
                        {{ landingPageNotice }}
                    </p>
                    <span
                            v-for="(link, index) in landingPageLinks"
                            :key="`landing-page-link-${index}`"
                    >
                    <a

                            :href="link.url"
                            class="tw-text-gray-700 tw-underline tw-font-sans tw-font-medium tw-transition-colors tw-duration-200 hover:tw-text-gray-300 tw-ml-1 tw-mr-1"
                            target="_blank"
                    >
                        {{ link.title }}
                    </a>
                    <span
                            v-if="index < landingPageLinks.length - 1"
                            class="tw-text-gray-700"
                    >
                        |
                    </span>
                </span>
                </div>
                <terms-and-policies
                        v-if="hasExtras"
                        :terms-of-use="termsOfUse"
                        :privacy-policy-url="privacyPolicyUrl"
                />
            </div>
        </div>
    </div>

    <div
            v-else
            class="landing-page-pro tw-flex tw-flex-col 3xl:tw-max-w-[120rem] tw-w-full"
            :class="`${backgroundColor}`"
    >
        <div class="tw-max-h-[30rem] tw-h-auto tw-py-10 tw-w-full tw-justify-center tw-items-center tw-grid-cols-[1fr_auto_1fr] tw-grid">
            <div
                    v-if="hasExtras"
                    class="lg:tw-pr-8 tw-max-h-[4.5rem] tw-h-full tw-flex-1 tw-w-full tw-pl-10 tw-flex tw-justify-start tw-items-center"
            >
                <div class="tw-max-h-[4.5rem] tw-max-w-[4.5rem] tw-h-full tw-w-full tw-mr-4">
                    <img
                            class="tw-max-h-[4.5rem] tw-max-w-[4.5rem]"
                            :src="require('@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/equal-housing-opportunity.png')"
                            alt="image desc"
                    >
                </div>
                <div class="tw-max-h-[4.5rem] tw-max-w-[4.5rem] tw-h-full tw-w-full">
                    <img
                            class="tw-max-h-[4.5rem] tw-max-w-[4.5rem]"
                            :src="require('@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/equal-housing-lender.png')"
                            alt="image desc"
                    >
                </div>
            </div>
            <div class="pro-user-wrapper tw-flex tw-flex-col tw-flex-auto tw-items-center tw-w-full tw-max-w-[64rem] tw-py-10">
                <div class="pro-user tw-flex tw-items-center tw-w-full tw-max-w-[64rem] tw-py-10 tw-justify-center">
                    <profile-and-company
                            :company-logo="companyLogo"
                            :user="user"
                    />
                    <div class="=tw-flex tw-flex-col">
                        <user-details
                                :display-name="displayName"
                                :agent-occupation="occupation"
                                :phones="phones"
                                :email="email"
                                :website="website"
                                :active-listings="activeListings"
                                :license="loanOfficerLicense"
                                :company-name="companyName"
                                :primary-color="primaryColor"
                        />
                        <div
                                v-if="hasExtras"
                                class="pro-socials-wrapper tw-flex tw-flex-1 tw-gap-4 tw-max-w-[28rem] tw-w-full lg:tw-ml-6 tw-mt-6 tw-ml-0"
                        >
                            <b-link
                                    v-if="youtube"
                                    :href="youtube.url"
                                    target="_blank"
                            >
                                <svg
                                        width="30"
                                        height="31"
                                        viewBox="0 0 30 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M12.3516 12.1338L18.7266 15.7197L12.3516 19.3057V12.1338ZM29.75 3.96582V27.3408C29.75 29.1338 28.2891 30.5283 26.5625 30.5283H3.1875C1.39453 30.5283 0 29.1338 0 27.3408V3.96582C0 2.23926 1.39453 0.77832 3.1875 0.77832H26.5625C28.2891 0.77832 29.75 2.23926 29.75 3.96582ZM26.9609 15.7197C26.9609 15.7197 26.9609 11.7354 26.4297 9.87598C26.1641 8.81348 25.3008 7.9502 24.3047 7.68457C22.3789 7.15332 14.875 7.15332 14.875 7.15332C14.875 7.15332 7.30469 7.15332 5.37891 7.68457C4.38281 7.9502 3.51953 8.81348 3.25391 9.87598C2.78906 11.7354 2.78906 15.7197 2.78906 15.7197C2.78906 15.7197 2.78906 19.6377 3.25391 21.5635C3.51953 22.626 4.38281 23.4229 5.37891 23.6885C7.30469 24.1533 14.875 24.1533 14.875 24.1533C14.875 24.1533 22.3789 24.1533 24.3047 23.6885C25.3008 23.4229 26.1641 22.626 26.4297 21.5635C26.9609 19.6377 26.9609 15.7197 26.9609 15.7197Z"
                                          :fill="primaryColor || '#064789'"
                                    />
                                </svg>
                            </b-link>
                            <b-link
                                    v-if="facebook"
                                    :href="facebook.url"
                                    target="_blank"
                            >
                                <svg
                                        width="30"
                                        height="31"
                                        viewBox="0 0 30 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M26.5625 0.77832C27.3594 0.77832 28.1562 1.17676 28.7539 1.77441C29.3516 2.37207 29.75 3.16895 29.75 3.96582V27.3408C29.75 28.2041 29.3516 29.001 28.7539 29.5986C28.1562 30.1963 27.3594 30.5283 26.5625 30.5283H17.3984V20.4346H21.25L21.9805 15.6533H17.3984V12.5986C17.3984 11.2705 18.0625 10.0088 20.1211 10.0088H22.1797V5.95801C22.1797 5.95801 20.3203 5.62598 18.4609 5.62598C14.7422 5.62598 12.2852 7.9502 12.2852 12.0674V15.6533H8.10156V20.4346H12.2852V30.5283H3.1875C2.32422 30.5283 1.52734 30.1963 0.929688 29.5986C0.332031 29.001 0 28.2041 0 27.3408V3.96582C0 3.16895 0.332031 2.37207 0.929688 1.77441C1.52734 1.17676 2.32422 0.77832 3.1875 0.77832H26.5625Z"
                                          :fill="primaryColor || '#064789'"
                                    />
                                </svg>
                            </b-link>
                            <b-link
                                    v-if="instagram"
                                    :href="instagram.url"
                                    target="_blank"
                            >
                                <svg
                                        width="30"
                                        height="31"
                                        viewBox="0 0 30 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M14.875 12.1338C15.8047 12.1338 16.668 12.5322 17.332 13.1963C17.9961 13.8604 18.3945 14.7236 18.3945 15.6533C18.3945 17.1143 17.5312 18.4424 16.2031 18.9736C14.875 19.5049 13.3477 19.1729 12.3516 18.1768C11.3555 17.1807 11.0234 15.6533 11.5547 14.3252C12.0859 12.9971 13.4141 12.1338 14.875 12.1338ZM23.1094 9.41113C23.707 10.8057 23.5742 14.126 23.5742 15.6533C23.5742 17.2471 23.707 20.5674 23.1094 21.9619C22.7773 22.8916 22.0469 23.6221 21.1172 23.9541C19.7227 24.5518 16.4023 24.4189 14.875 24.4189C13.2812 24.4189 9.96094 24.5518 8.56641 23.9541C7.63672 23.6221 6.90625 22.8916 6.57422 21.9619C6.04297 20.5674 6.10938 17.2471 6.10938 15.6533C6.10938 14.126 6.04297 10.8057 6.57422 9.41113C6.90625 8.48145 7.63672 7.75098 8.56641 7.41895C9.96094 6.82129 13.2812 6.9541 14.875 6.9541C16.4023 6.9541 19.7227 6.82129 21.1172 7.41895C22.0469 7.75098 22.7773 8.48145 23.1094 9.41113ZM14.875 21.0986C16.2695 21.165 17.6641 20.5674 18.7266 19.5713C19.7227 18.5088 20.3203 17.1143 20.3203 15.6533C20.3203 13.4619 18.9922 11.4697 16.9336 10.6729C14.875 9.80957 12.5508 10.2744 11.0234 11.8682C9.42969 13.3955 8.96484 15.7197 9.82812 17.7783C10.625 19.8369 12.6172 21.0986 14.875 21.0986ZM20.5195 11.2705C20.8516 11.2705 21.1836 11.1377 21.3828 10.9385C21.6484 10.6729 21.7812 10.3408 21.7812 10.0088C21.7812 9.47754 21.4492 9.0127 20.9844 8.81348C20.5195 8.61426 19.9883 8.74707 19.5898 9.14551C19.2578 9.47754 19.125 10.0088 19.3242 10.4736C19.5234 11.0049 19.9883 11.2705 20.5195 11.2705ZM26.5625 0.77832C27.3594 0.77832 28.1562 1.17676 28.7539 1.77441C29.3516 2.37207 29.75 3.16895 29.75 3.96582V27.3408C29.75 28.2041 29.3516 29.001 28.7539 29.5986C28.1562 30.1963 27.3594 30.5283 26.5625 30.5283H3.1875C2.32422 30.5283 1.52734 30.1963 0.929688 29.5986C0.332031 29.001 0 28.2041 0 27.3408V3.96582C0 3.16895 0.332031 2.37207 0.929688 1.77441C1.52734 1.17676 2.32422 0.77832 3.1875 0.77832H26.5625ZM25.3672 20.0361C25.5 18.3096 25.5 13.0635 25.3672 11.3369C25.3008 9.61035 24.9023 8.08301 23.707 6.8877C22.4453 5.62598 20.918 5.22754 19.2578 5.16113C17.4648 5.02832 12.2188 5.02832 10.4922 5.16113C8.76562 5.22754 7.23828 5.62598 6.04297 6.82129C4.78125 8.08301 4.38281 9.61035 4.31641 11.2705C4.18359 13.0635 4.18359 18.3096 4.31641 20.0361C4.38281 21.7627 4.78125 23.29 6.04297 24.4854C7.23828 25.7471 8.76562 26.1455 10.4922 26.2119C12.2188 26.3447 17.4648 26.3447 19.2578 26.2119C20.918 26.1455 22.4453 25.7471 23.707 24.4854C24.9023 23.29 25.3008 21.7627 25.3672 20.0361Z"
                                          :fill="primaryColor || '#064789'"
                                    />
                                </svg>
                            </b-link>
                            <b-link
                                    v-if="linkedin"
                                    :href="linkedin.url"
                                    target="_blank"
                            >
                                <svg
                                        width="30"
                                        height="31"
                                        viewBox="0 0 30 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M27.625 0.77832C28.7539 0.77832 29.75 1.77441 29.75 2.96973V28.4033C29.75 29.5986 28.7539 30.5283 27.625 30.5283H2.05859C0.929688 30.5283 0 29.5986 0 28.4033V2.96973C0 1.77441 0.929688 0.77832 2.05859 0.77832H27.625ZM8.96484 26.2783V12.1338H4.58203V26.2783H8.96484ZM6.77344 10.1416C8.16797 10.1416 9.29688 9.0127 9.29688 7.61816C9.29688 6.22363 8.16797 5.02832 6.77344 5.02832C5.3125 5.02832 4.18359 6.22363 4.18359 7.61816C4.18359 9.0127 5.3125 10.1416 6.77344 10.1416ZM25.5 26.2783V18.5088C25.5 14.7236 24.6367 11.7354 20.1875 11.7354C18.0625 11.7354 16.6016 12.9307 16.0039 14.0596H15.9375V12.1338H11.7539V26.2783H16.1367V19.3057C16.1367 17.4463 16.4688 15.6533 18.793 15.6533C21.0508 15.6533 21.0508 17.7783 21.0508 19.3721V26.2783H25.5Z"
                                          :fill="primaryColor || '#064789'"
                                    />
                                </svg>
                            </b-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-px-10 tw-pb-5">
            <div class="tw-pb-1">
                <p class="tw-inline">
                    {{ landingPageNotice }}
                </p>
                <span
                        v-for="(link, index) in landingPageLinks"
                        :key="`landing-page-link-${index}`"
                >
                    <a

                            :href="link.url"
                            class="tw-text-gray-700 tw-underline tw-font-medium tw-transition-colors tw-duration-200 hover:tw-text-gray-300 tw-ml-1 tw-mr-1"
                            target="_blank"
                    >
                        {{ link.title }}
                    </a>
                    <span
                            v-if="index < landingPageLinks.length - 1"
                            class="tw-text-gray-700"
                    >
                        |
                    </span>
                </span>
            </div>
            <terms-and-policies
                    v-if="hasExtras"
                    :terms-of-use="termsOfUse"
                    :privacy-policy-url="privacyPolicyUrl"
            />
        </div>
    </div>
</template>

<script>
import {
    SOCIAL_LINKS
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSocialLinkAppResource";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import {formatStringPhoneUS} from "../../../../helpers/stringHelpers";
import {privacyPolicy, termsOfUse} from "@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks";
import ProfileAndCompany from "./ProfileAndCompany.vue";
import UserDetails from "./UserDetails.vue";
import TermsAndPolicies from "./TermsAndPolicies.vue";
import isEmpty from "lodash/isEmpty";
import UserAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource";
import StorageAvatar from "../../../StorageImage/StorageAvatar.vue";


export default {
    name: "LandingPageProUser",
    components: {TermsAndPolicies, ProfileAndCompany, UserDetails, StorageAvatar},
    mixins: [
        IsMobileMixin
    ],
    props: {
        user: {
            type: UserAppResource,
            required: true,
        },
        companyLogo: {
            type: String,
            default: ''
        },
        companyName: {
            type: String,
            default: ''
        },
        displayName: {
            type: String,
            default: ''
        },
        phones: {
            type: Array,
            default: () => []
        },
        email: {
            type: String,
            default: ''
        },
        occupation: {
            type: Object,
            default: () => {
                return {};
            },
        },
        socialLinks: {
            type: Array,
            default: () => []
        },
        loanOfficerLicense: {
            type: Object,
            default: () => {
            },
        },
        hasExtras: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: '',
        },
        landingPageNotice: {
            type: String,
            required: false,
        },
        landingPageLinks: {
            type: Array,
            required: false,
        },
        primaryColor:  {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            SOCIAL_LINKS,
            termsOfUse,
        };
    },
    computed: {
        website() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.WEBSITE;
            })[0] || undefined;        },
        activeListings() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.LISTING_WEBSITE;
            })[0] || undefined;
        },
        youtube() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.YOUTUBE;
            })[0] || undefined;
        },
        facebook() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.FACEBOOK;
            })[0] || undefined;
        },
        instagram() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.INSTAGRAM;
            })[0] || undefined;
        },
        linkedin() {
            return this.socialLinks.filter(item => {
                return item.type === SOCIAL_LINKS.LINKEDIN;
            })[0] || undefined;
        },
        privacyPolicyUrl() {
            if (window.organizationPrivacyPolicyUrl) {
                return window.organizationPrivacyPolicyUrl;
            }

            return privacyPolicy;
        },
    },
    methods: {
        isEmpty,
        formatStringPhoneUS,
    },
};
</script>
